import Vue from 'vue'
import Router from 'vue-router'
import Index from '../views/index/index'
// import Index from '../components/Index'
import Fruit from '../components/Fruit'
import Fashion from '../components/Fashion'
import Product from '../views/product/index'
import About from '../views/about/index'
import Company from '../views/company/index'


Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/product',
            name: 'Product',
            component: Product
        },
        {
            path: '/fruit',
            name: 'Fruit',
            component: Fruit
        },
        {
            path: '/about',
            name: 'About',
            component: About
        },
        {
            path: '/fashion',
            name: 'Fashion',
            component: Fashion
        },
        {
            path: '/company',
            name: 'Company',
            component: Company
        },
    ]
})
